import React, {useState, useContext, useRef} from 'react';
import {useParams} from 'react-router-dom';
import {SpreadsheetComponent} from '@syncfusion/ej2-react-spreadsheet';
import QuestionContext from '../Utils/context';
import axios from 'axios';
import {Button, Col, Form, Row} from "react-bootstrap";
import {ACTIONS} from '../Utils/action';

export default function InputTable({
  QUESTION_ID,
  JSON_TABLE,
  dispatchNotif,
  disabled,
  CELL_FORMULA,
}) {


  let spreadsheetRef = useRef(null);
  const {sheets, instrument, dispatchQuestions} = useContext(QuestionContext);
  const [cell, setCell] = useState(CELL_FORMULA || ``);

  const handleCreated = async () => {

    if (!spreadsheetRef.current) return;

    const response = await axios.get(
      `${process.env.REACT_APP_API_HOST}instruments/${instrument.INSTRUMENT_ID}/calculation-json`,
      {headers: {Authorization: `Bearer ${JSON.parse(localStorage.getItem('authenticated')).token}`}}
    )

    const sheetFormula = response.data;

    spreadsheetRef.current.unprotectSheet('perhitungan');
    spreadsheetRef.current.openFromJson({file: sheetFormula});
    spreadsheetRef.current.sheets[0].isProtected = false;

  }

  const handleSheetChange = async ({target: {value}}) => {

    const response = await axios.put(
      `${process.env.REACT_APP_API_HOST}questions/${QUESTION_ID}`,
      {JSON_TABLE: value},
      {headers: {Authorization: `Bearer ${JSON.parse(localStorage.getItem('authenticated')).token}`}}
    );

    dispatchNotif({
      place: `br`,
      message: `Update Success...`,
      type: `success`,
    });

    dispatchQuestions({
      type: ACTIONS.EDIT,
      payload: {
        QUESTION_ID: QUESTION_ID,
        JSON_TABLE: response.data.JSON_TABLE,
      }
    });
  }


  const handleSelectCell = (event) => {
    setCell(event.range?.split(':')?.shift() ?? ``);
  }

  const handleFormulaCellClick = async () => {
    const response = await axios.put(
      `${process.env.REACT_APP_API_HOST}questions/${QUESTION_ID}`,
      {CELL_FORMULA: cell},
      {headers: {Authorization: `Bearer ${JSON.parse(localStorage.getItem('authenticated')).token}`}}
    );

    dispatchNotif({
      place: `br`,
      message: `Update Success...`,
      type: `success`,
    });

    dispatchQuestions({
      type: ACTIONS.EDIT,
      payload: {
        QUESTION_ID: QUESTION_ID,
        CELL_FORMULA: response.data.CELL_FORMULA,
      }
    });
  }

  return (
    <Row>
      <Col>
        <Form.Group>
          <Form.Label>Sheet</Form.Label>
          <Form.Control
            value={JSON_TABLE}
            defaultValue={-1}
            disabled={disabled}
            onChange={handleSheetChange}
            as="select"
          >
            <option disabled value={-1}>Select Sheet...</option>
            {sheets && sheets.map((sheet, key) => (
              <option key={key} value={sheet}>{sheet}</option>
            ))}
          </Form.Control>
        </Form.Group>
      </Col>
      <Col>
        <Form.Group>
          <Form.Label>Select Score from 'Perhitungan' Sheet</Form.Label>
          <SpreadsheetComponent
            // queryCellInfo={handleQueryCell}
            ref={spreadsheetRef}
            select={handleSelectCell}
            isProtected={false}
            showSheetTabs={false}
            created={handleCreated}
            allowEditing={true}
          />
        </Form.Group>
        <Form.Group>
          <Form.Label>Selected Formula Cell</Form.Label>
          <Row>
            <Col>
              <Form.Control
                readOnly={true}
                value={cell}
              />
            </Col>
            {!disabled && (
              <Col>
                <Button
                  variant="primary"
                  onClick={handleFormulaCellClick}
                >
                  Set
                </Button>
              </Col>
            )}
          </Row>
        </Form.Group>
      </Col>
    </Row>
  );
}